// Stub for main-thread imports; live scanning uses the bundled worker WASM instead.
module.exports = {
  readBarcodes: async () => [],
  setZXingModuleOverrides: () => undefined,
  prepareZXingModule: async () => undefined,
  purgeZXingModule: async () => undefined,
};
